import React, { useEffect, useState } from 'react';
import { Copy, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { TEMPLATES } from '../lib/content';
import { waLink, mergeTemplate } from '../lib/whatsapp';

export default function Templates() {
  const [contacts, setContacts] = useState([]);
  const [selected, setSelected] = useState(TEMPLATES[0].key);
  const [contactId, setContactId] = useState('');
  const [vars, setVars] = useState({});
  const tpl = TEMPLATES.find(t => t.key === selected);
  const c = contacts.find(x => x.id === contactId);

  useEffect(() => { api.get('/contacts').then(r => setContacts(r.data)); }, []);
  useEffect(() => { setVars({ client_name: c?.name || '', artist_name: c?.name || '' }); }, [contactId]);

  const filled = mergeTemplate(tpl.body, { ...vars, client_name: vars.client_name || c?.name || '{client_name}' });
  const logSend = async (channel) => {
    await api.post('/template-log', { contact_id: contactId, contact_name: c?.name, template_key: selected, channel, phone: c?.phone || '' });
  };
  const send = async () => { await logSend('whatsapp'); window.open(waLink(c?.phone, filled), '_blank'); };
  const copy = async () => { await logSend('copy'); navigator.clipboard.writeText(filled); toast.success('Copied'); };

  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-4xl mx-auto">
      <div className="eyebrow">Library</div>
      <h1 className="serif text-[28px] mb-5">Message Templates</h1>

      <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-4">
        <div className="card-cream p-2 max-h-[70vh] overflow-y-auto">
          {['client','vendor','internal','b2b'].map(aud => {
            const list = TEMPLATES.filter(t => t.audience === aud);
            if (!list.length) return null;
            return (
              <div key={aud} className="mb-3">
                <div className="eyebrow px-2 py-1">{aud}</div>
                {list.map(t => (
                  <button key={t.key} onClick={() => setSelected(t.key)} className="w-full text-left px-2 py-2 text-sm rounded" style={{background: selected===t.key?'var(--cream-alt)':'transparent', color:'var(--charcoal)'}} data-testid={`tpl-${t.key}`}>
                    {t.label}
                    {!t.finalised && <span className="ml-1 text-[9px] tracking-[0.14em] uppercase" style={{color:'var(--pending)'}}> · draft</span>}
                  </button>
                ))}
              </div>
            );
          })}
        </div>

        <div>
          <div className="card-cream p-4 mb-4">
            <div className="eyebrow mb-2">Recipient (optional)</div>
            <select value={contactId} onChange={e => setContactId(e.target.value)} data-testid="tpl-contact">
              <option value="">—</option>{contacts.map(c => <option key={c.id} value={c.id}>{c.name} — {c.phone}</option>)}
            </select>
          </div>
          <div className="card-cream p-5">
            <div className="flex items-center justify-between mb-3">
              <h2 className="serif text-[22px]">{tpl.label}</h2>
              {!tpl.finalised && <span className="needs-conf-badge">Draft copy — replace before sending</span>}
            </div>
            <textarea rows={14} value={filled} onChange={e => { /* preview only */ }} readOnly className="mb-3 font-mono text-sm" data-testid="tpl-preview"/>
            <div className="flex gap-2 flex-wrap">
              <button className="btn-gold" onClick={send} data-testid="tpl-send"><MessageCircle size={14}/> WhatsApp</button>
              <button className="btn-ghost" onClick={copy} data-testid="tpl-copy"><Copy size={14}/> Copy</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
